var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch",class:{'open': this.value, 'close': !this.value},on:{"click":_vm.onClick}},[_c('div',{staticClass:"oval"})])}
var staticRenderFns = []

export { render, staticRenderFns }